import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// STAFF SALARY / PF / ESI (SEP) PAYMENT APIs
// Legacy route: /HR/HRCCSalEsiPfPayMain
// ==============================================

// 1. Get Consolidate Numbers for a Payment Type / Month / Year (GET)
export const getConsolidateNoForHRSep = async ({ paymentFor, month, year }) => {
    try {
        const queryParams = new URLSearchParams({
            PaymentFor: paymentFor,
            Month: month,
            Year: year,
        });

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetConsildateNoForHRSep?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        console.error('❌ Get Consolidate No For HR Sep API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Cost Center-wise Paid Amount for the selected Consolidate Numbers (POST)
export const getCostcenterPaidAmount = async ({ paymentFor, month, year, selectedConsolidateno }) => {
    try {
        const payload = {
            PaymentFor: paymentFor,
            Month: String(month),
            Year: String(year),
            SelectedConsolidateno: selectedConsolidateno,
        };

        const response = await axios.post(
            `${API_BASE_URL}/HR/GetCostcenterPaidAmount`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        console.error('❌ Get Costcenter Paid Amount API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Company Bank Details for the payment form (GET)
export const getCompanyBankDetails = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetCompanyBankDetails`,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        console.error('❌ Get Company Bank Details API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Save the Staff SEP Payment (POST)
export const saveHRSEPPayment = async (params) => {
    try {
        const payload = {
            PaymentFor: params.paymentFor,
            Month: String(params.month),
            Year: String(params.year),
            CCCodes: params.ccCodes,
            CCAmounts: params.ccAmounts,
            ContributionTypes: params.contributionTypes,
            BankID: parseInt(params.bankId, 10),
            ModeofPay: params.modeOfPay,
            PaymentNo: params.paymentNo,
            BankTotal: String(params.bankTotal),
            PaymentAmount: String(params.bankTotal),
            PaymentDate: params.paymentDate,
            Remarks: params.remarks,
            SelectedConsolidateno: params.selectedConsolidateno,
            RoleId: params.roleId,
            Createdby: params.createdBy,
        };

        const response = await axios.post(
            `${API_BASE_URL}/HR/HRSaveCCSEPPaymets`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        console.error('❌ Save HR SEP Payment API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
